<!--
 * @Author: wenpan.cao@ecarxgroup.com
 * @Date: 2023-07-06 16:07:14
 * @LastEditTime: 2023-08-08 15:59:05
 * @LastEditors: wenpan.cao@ecarxgroup.com
 * @Description: 描述
-->
<template>
  <div>
    <template v-if="dataList.length">
      <div class="process-content">
      <template v-for="item in dataList">
        <div class="processs-item"  :key="item.instanceId">
          <a-checkbox  :value="item.instanceId" @change="onChange" :checked="checkedItem(item.instanceId)"/>
          <div class="process-info" @click="checkProcess(item)">
            <div class="flex-b-item">
              <span class="process-title">{{item.subject}}</span>
              <a-tag :color="STATUE_STYLE_MAP[item.status]">{{$t(`wg.status.${item.status}`)}}</a-tag>
            </div>
            <!-- 根据tab不同展示不同数据 -->
            <!-- 已发起不展示发起人 -->
            <span v-if="isShowProposer">{{$t('wg.drafter')}}{{item.drafterName}}</span>
            <span>{{$t('wg.drafterDept')}}{{item.drafterDept}}</span>
            <span>{{item.reqDate}}</span>
          </div>
        </div>
      </template>
      </div>
      <a-pagination style="text-align: right; margin-top:12px" size="small" :defaultPageSize="10" :total="total" @change="changePage"/>
    </template>
    <a-empty v-else/>
  </div>
</template>
<script>

export default {
  name: 'ProcessItem',
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Array,
      default: () => [],
    },
    /**
     * 当前激活tab 1待办 2已办 3抄送我 4已发起 默认展示已发起
     */
    tab: {
      type: String,
      default: '4',
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      STATUE_STYLE_MAP: {
        running: 'blue',
        back: 'red',
        end: 'green',
        manualend: 'orange',
        revoke: 'purple',
      },
    };
  },

  computed: {
    selectedData() {
      return this.selected;
    },
    isShowProposer() {
      return this.tab !== '4';
    },
    busy() {
      return this.busyFlag;
    },
  },
  methods: {
    onChange(e) {
      const { checked, value } = e.target;
      let selectArr = this.selectedData;
      if (checked) {
        selectArr.push(value);
      } else {
        selectArr = this.selectedData.filter(item => item !== value);
      }
      this.$emit('onChange', selectArr);
    },
    checkedItem(item) {
      return this.selectedData.indexOf(item) !== -1;
    },
    // 查看流程
    checkProcess(item) {
      window.open(`${window.location.origin}/#/pages/flow/redirect?instanceId=${item.instanceId}`);
    },
    changePage(page) {
      this.$emit('changePage', page);
    },
  },
};
</script>
<style lang="less" scoped>
.process-content{
  height: calc(100vh - 300px);
  overflow-y: scroll;
}
.processs-item{
  display: flex;
  align-items: center;
  margin-top: 12px;
}
.process-info{
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid #e8e8e8;
  border-radius: 2px;
  margin-left: 24px;
  padding: 12px;
  font-size: 12px;
  color: #999;
  cursor: pointer;
}
.process-title{
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}
.flex-b-item{
  display: flex;
  justify-content: space-between;
}
.loading-position{
  position: absolute;
  bottom: 40px;
  width: 100%;
  text-align: center;
}
</style>
